"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getVariantMaxPaxByType = void 0;
const getOrderLinePax_1 = require("./getOrderLinePax");
const getVariantMaxPaxByType = (variant, type) => {
    if (!variant)
        return 0;
    if (!variant.order_lines)
        return 0;
    return variant.order_lines
        .filter((orderLine) => orderLine.type.toLocaleLowerCase() === type.toLowerCase())
        .reduce((acc, cur) => {
        const maxPax = (0, getOrderLinePax_1.getOrderLinePax)(cur);
        return Math.max(acc, maxPax);
    }, 0);
};
exports.getVariantMaxPaxByType = getVariantMaxPaxByType;
